<template>
  <div v-if="data && nowData && curatedData" class="fourTimesFourPage">
    <Landing
      :data="data.liveCampaignSlots"
      :serverTime="nowData"
      :onClick="handleClick"
      :viewEventData="prepareViewEventData"
    />

    <DiscountsHourly
      :data="data.futureCampaignSlots"
      :serverTime="nowData"
      :onClick="handleClick"
      :viewEventData="prepareViewEventData"
    />

    <PastOpportunities
      :product="data.missedCampaignSlots"
      :onClick="handleClick"
      :viewEventData="prepareViewEventData"
    />

    <!-- <CuratedList
      v-if="curatedData"
      :data="curatedData" 
    /> -->

    <MobileApp v-if="!isMobileAppControl()" />

    <Footer />
  </div>
</template>

<script>

import Landing from "../../partials/Landing/Landing";
import DiscountsHourly from "../../partials/DiscountsHourly/DiscountsHourly";
import PastOpportunities from "../../partials/PastOpportunities/PastOpportunities";
import CuratedList from "../../partials/CuratedList/CuratedList";
import MobileApp from "../../partials/MobileApp/MobileApp";
import Footer from "../../partials/Footer/Footer";
import { productService } from "../../service/product/productService";
import { curatedListService } from "../../service/curatedlist/curatedListService";
import { nowService } from "../../service/now/nowService";
import { isMobileAppControl } from "../../common/agent/agentUtils";
import { eventClick, eventView } from '../../analytics/davinci/davinci';
import { SLOT_NAMES } from '../../analytics/davinci/constants';

export default {
  name: "App",
  components: {
    Landing,
    DiscountsHourly,
    PastOpportunities,
    CuratedList,
    MobileApp,
    Footer
  },
  data() {
    return {
      loading: "false",
      data: "",
      curatedData: "",
      nowData:"",
      isPreview: window.isPreview ? window.isPreview : undefined,
      expectedNow: window.expectedNow ? window.expectedNow : undefined,
      slotNameLive: SLOT_NAMES.LIVE_CAMPAIGN_SLOTS,
      slotNameFuture: SLOT_NAMES.FUTURE_CAMPAIGN_SLOTS,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    isMobileAppControl,
    fetchData() {
      this.loading = true;

      productService().then(res => {
        this.loading = false;
        this.data = res.data.data;
      });

      curatedListService().then(res => {
        this.loading = false;
        this.curatedData = res.data.data;
      });

      nowService().then(res => {
        this.loading = false;
        this.nowData = res.data.data;
      });
    },

    slotPositionFind: function(data, slot) {
      return data.findIndex((item) => item.id === slot.id);
    },

    bucketIndexFind: function(data, slot) {
      return data.map(item => item.campains.find(item => item.id === slot.id)).findIndex(item => item);
    },

    handleClick: function (item, slot, slotName, index) {
      let slotPositionIndex;
      let data = this.data[slotName];

      if(slotName === this.slotNameLive || slotName === this.slotNameFuture) {
        slotPositionIndex = this.slotPositionFind(data, slot);

        eventClick({
          bucket_position: slotPositionIndex + 1,
          bucket_name: slot && slot.name,
          id: item.id,
          placement: slotName,
          position: index + 1,
        });
      } else {
        let bucketIndex = this.bucketIndexFind(data, slot);
        slotPositionIndex = this.slotPositionFind(item, slot);

        eventClick({
          bucket_position: bucketIndex + 1,
          bucket_name: data[bucketIndex].name,
          id: slot.id,
          placement: slotName,
          position: slotPositionIndex + 1,
        });
      }
    },

    prepareViewEventData: function (item, slot, slotName, index) {
      let slotPositionIndex;
      let data = this.data[slotName];

      if(slotName === this.slotNameLive || slotName === this.slotNameFuture) {
        slotPositionIndex = this.slotPositionFind(data, slot);

        return eventView({
          bucket_position: slotPositionIndex + 1,
          bucket_name: slot && slot.name,
          id: item.id,
          placement: slotName,
          position: index + 1,
        });

      } else {
        let bucketIndex = this.bucketIndexFind(data, slot);
        slotPositionIndex = this.slotPositionFind(item, slot);

        return eventView({
          bucket_position: bucketIndex + 1,
          bucket_name: data[bucketIndex].name,
          id: slot.id,
          placement: slotName,
          position: slotPositionIndex + 1,
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/FourTimesFour/FourTimesFour.vue